import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./sidebar";
import Navbar from "../staticView/globalComponents/Navbar";
import Footer from "../staticView/globalComponents/Footer";
import TopBar from "../staticView/globalComponents/TopBar";
import { useState } from "react";
import { FaBars, FaAngleLeft } from "react-icons/fa";
import { useAppSelector } from "../../store/hooks";
import { isUrisBrand, isVelvetUiActive } from "../../utils/brandLogo";

const UNITS_PORTAL_ROUTES = [
  "/dashboard/admin/units",
  "/dashboard/admin/units/recent",
  "/dashboard/admin/units/ledger",
  "/dashboard/admin/marked-units",
];

function Layout() {
  const [hideSidebar, setHideSidebar] = useState(false);
  const location = useLocation();
  const { user, isAuth } = useAppSelector((state) => state.auth);
  const isUnitsPortal = UNITS_PORTAL_ROUTES.includes(location.pathname);
  const isVelvet = isVelvetUiActive(user, location.pathname);
  const isUris = isUrisBrand(user);

  const isOnboardingUser =
    isAuth &&
    user?.role === "User" &&
    !user.verified &&
    !user.verifySmile &&
    !user.verifyPhotoRecolour;

  if (isOnboardingUser) {
    return (
      <div className="w-full bg-white min-h-screen flex flex-col">
        <div className="sticky top-0 z-50 w-full">
          <Navbar handleGoogleLogin={() => {}} rel={null} />
        </div>
        <main className="flex-1 bg-[#F4F4F2] py-4 md:py-6 px-12">
          <div className="w-full">
            <Outlet />
          </div>
        </main>
      </div>
    );
  }

  if (isUnitsPortal) {
    return (
      <div className="w-full">
        <div className="flex h-screen w-full flex-col items-center overflow-hidden">
          <div className="sticky top-0 z-50 w-full shrink-0">
            <TopBar />
          </div>
          <div className="flex w-full min-h-0 flex-1 overflow-hidden">
            <main className="h-full w-full flex-1 overflow-hidden bg-[#F4F4F2] p-2 md:p-3">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`w-full ${isUris ? "bg-[#141517]" : "bg-white"}`}>
      <div className="min-h-screen w-full flex flex-col">
        <div className="sticky top-0 z-50 w-full shrink-0">
          <Navbar handleGoogleLogin={() => {}} rel={null} />
        </div>

        <div className="relative flex flex-1 w-full min-h-0">
          <div
            className={`hidden md:block flex-shrink-0 border-r-2 transition-all duration-300 ${
              isUris
                ? "border-[#2a2b31] bg-[#141517]"
                : isVelvet
                  ? "border-[#DDDDD8] bg-[#E8D9C4]"
                  : "border-[#DDDDD8] bg-[#262626]"
            } ${
              hideSidebar ? "w-12" : isUris ? "w-[4.75rem]" : "w-[15%]"
            }`}
          />

          {hideSidebar && !isUris && (
            <button
              type="button"
              onClick={() => setHideSidebar(false)}
              aria-label="Expand sidebar"
              className={`hidden md:flex h-12 w-12 absolute top-0 left-0 z-30 items-center justify-center rounded-r-xl ${
                isVelvet
                  ? "bg-[#D4C4A8] text-[#2C2C2C]"
                  : "bg-[#2b9fb4] text-white"
              }`}
            >
              <FaBars />
            </button>
          )}

          <div
            className={
              hideSidebar
                ? "md:hidden"
                : `md:absolute md:inset-y-0 md:left-0 ${
                    isUris
                      ? "md:w-[4.75rem] md:bg-[#141517]"
                      : isVelvet
                        ? "md:w-[15%] md:bg-[#E8D9C4]"
                        : "md:w-[15%] md:bg-[#262626]"
                  }`
            }
          >
            {!hideSidebar && !isUris && (
              <button
                type="button"
                onClick={() => setHideSidebar(true)}
                aria-label="Collapse sidebar"
                className={`hidden md:flex h-12 w-12 absolute top-0 right-0 z-30 items-center justify-center rounded-l-xl ${
                  isVelvet
                    ? "bg-[#D4C4A8] text-[#2C2C2C]"
                    : "bg-[#2b9fb4] text-white"
                }`}
              >
                <FaAngleLeft />
              </button>
            )}
            <Sidebar />
          </div>

          <div
            className={`flex-1 min-w-0 min-h-0 ${
              isUris
                ? "bg-[#141517]"
                : isVelvet
                  ? "bg-[#FCF2E5]"
                  : "bg-[#F4F4F2]"
            }`}
          >
            <main className="min-h-screen overflow-y-auto overflow-x-auto md:overflow-x-hidden p-4 pt-16 md:p-6 md:pt-6">
              <Outlet />
            </main>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Layout;
